import { jsx as r } from "react/jsx-runtime";
const e = ({ onClick: o }) => /* @__PURE__ */ r(
  "div",
  {
    id: "tour-overlay",
    "data-testid": "tour-overlay",
    onClick: () => o("Clique no overlay")
  }
);
export {
  e as TourOverlay
};
